<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            label="Tender Code"
            prepend-icon="mdi-magnify"
            v-model="tenderCode"
            solo
            clearable
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            label="Tender Name"
            v-model="tenderName"
            solo
            clearable
          ></v-text-field>
        </v-col>
        <v-col>
          <v-btn tile color="blue lighten-4" v-bind:to="{ path: 'newTender' }">
            <v-icon>mdi-plus</v-icon>
            Add new tender
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
            v-if="isAdminUser && isSyncWithProdFlag()"
            tile color="blue lighten-4"
            @click="synchronizeWithProduction">
            <v-icon>mdi-sync</v-icon>
            Synchronize with production
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-simple-table class="elevation-10">
        <template v-slot:default>
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Tender Code</th>
              <th scope="col">Tender Name</th>
              <th scope="col">Tender Type</th>
              <th scope="col">Tender Group</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tender in tenders" v-if="isTenderFiltered(tender)">
              <td>{{ tender.id }}</td>
              <td>{{ tender.tenderCode }}</td>
              <td>{{ tender.tenderName }}</td>
              <td>{{ tender.tenderType }}</td>
              <td>{{ tender.tenderGroup }}</td>
              <td>
                <router-link
                  v-if="isAdminUser"
                  class="btn btn-edit"
                  v-bind:to="{ path: 'editTender', query: { id: tender.id } }"
                >
                  <v-icon>mdi-pencil</v-icon>
                  <span class="editspan">Edit</span>
                </router-link>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { parameters } from "../../parameters";
import { httpClient, authState } from "../../requesters/httpClient";
import { USER_ROLE } from "../../requesters/userConstants";

export default {
  name: "Tenders",
  data() {
    return {
      tenders: [],
      tenderCode: "",
      tenderName: null,
    };
  },
  computed: {
    isAdminUser() {
      return authState.role === "ROLE_ADMIN";
    }
  },
  async mounted() {
    await httpClient
      .get(`${parameters.posdataRefUrl}/tenders`)
      .then((response) => {
        this.tenders = response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    isTenderFiltered: function (tender) {
      return (
        (this.tenderCode === null ||
          this.tenderCode === "" ||
          this.tenderCode == tender.tenderCode) &&
        (this.tenderName === null ||
          this.tenderName === "" ||
          tender.tenderName.includes(this.tenderName))
      );
    },
    synchronizeWithProduction: async function () {
      try {
        if (!confirm('Are you sure you want to synchronize all tenders with production ?')) {
          return;
        }

        await httpClient.post(
          `${parameters.posdataRefUrl}/tenders/synchronize-with-production`
        );

        await this.reloadTenders();
        await this.$alert("Tenders have been synchronized with production");

      } catch (error) {
        await this.$alert("Error synchronizing tenders");
        throw error;
      }
    },
    reloadTenders: async function () {
      return await httpClient
        .get(`${parameters.posdataRefUrl}/tenders`)
        .then((response) => {
          this.tenders = response.data;
        })
        .catch((error) => {
          throw error;
        });
    },
    isSyncWithProdFlag: function (){
      return parameters.syncWithProdFlag === true;
    }
  },
};
</script>





// WEBPACK FOOTER //
// src/components/tenders/Tenders.vue